import React from 'react';
import { Box } from '@material-ui/core';

import { MediaItemFragment, PropertyType } from 'src/generated/graphql';
import { ImageSlider } from 'src/components/ImageSlider/ImageSlider';
import { OfficeCount } from './OfficeCount';
import { PropertyTypeBox } from './PropertyTypeBox';

type CardSliderProps = {
    underOfferCount?: number;
    comingSoonCount?: number;
    letCount?: number;
    officeCount: number;
    images: MediaItemFragment[];
    type: PropertyType
}

export const CardSlider = ({
    officeCount,
    underOfferCount,
    comingSoonCount,
    letCount,
    images,
    type
}: CardSliderProps) => {
    let useWhichAvailablity = 'office';
    if (underOfferCount && comingSoonCount && letCount) {
        if (officeCount > 0) {
            useWhichAvailablity = 'office';
        }
        if (underOfferCount > 0 && comingSoonCount > 0 && letCount > 0 && officeCount === 0) {
            useWhichAvailablity = 'underOffer';
        }
        if (underOfferCount > 0 && comingSoonCount === 0 && officeCount === 0 && letCount === 0) {
            useWhichAvailablity = 'underOffer';
        }
        if (comingSoonCount > 0 && underOfferCount === 0 && officeCount === 0 && letCount === 0) {
            useWhichAvailablity = 'coming soon';
        }
        if (letCount > 0 && underOfferCount === 0 && officeCount === 0 && comingSoonCount === 0) {
            useWhichAvailablity = 'let';
        }
    }
    return (
        <Box position="relative">
            <ImageSlider images={images} showTitle={false} size={1} showCount={false} arrowsOut />
            <OfficeCount count={officeCount} useWhichAvailablity={useWhichAvailablity} />
            <PropertyTypeBox type={type} />
        </Box>
    );
};
